import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = {
  key: 0,
  class: "body_content"
}
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"1rem"} }
const _hoisted_5 = { class: "sub1" }

import BoardNavbar from "@/views/business/Navbar.vue";
import Banner from "@/components/Banner.vue";
import { NIcon } from "naive-ui";
import { ChevronForward } from "@vicons/ionicons5";
import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
import * as constant from "@/constants/constant";

export default /*@__PURE__*/_defineComponent({
  __name: 'Table',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn, isOrgUser } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    } else {
      if (!isOrgUser.value) {
        await useAlert("기관 사용자만 사용이 가능합니다.");
        router.push({ name: USER_ROUTES.Home.Name });
      }
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "기관",
          subtitle: "기관",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          (_unref(isOrgUser))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createElementVNode("h1", {
                    class: "sub_subject",
                    style: {"margin-bottom":"0"}
                  }, [
                    _createTextVNode(" [기관] 전문가 교육 기본정보"),
                    _createElementVNode("span")
                  ], -1)),
                  _createVNode(_component_router_link, {
                    to: {
              name: _unref(USER_ROUTES).Mypage.Order.Org.Request.Name,
              params: { pid: constant.OrderType.EXPERT },
            },
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createVNode(_component_n_button, {
                        type: "primary",
                        onClick: navigate,
                        role: "link"
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode(" 신청서 작성 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"title_description\" data-v-e1d0e61e> 현장 전문가 ‧ 학습 및 진로상담 전문가 ‧ 심리 및 교육 관련 분야 전문가 외 </div><br data-v-e1d0e61e><div data-v-e1d0e61e> ◰ [전문가 교육] PUTT2.0 학습진로상담 전문가 교육 및 성장‧폴리오 전문가 과정(✔) </div><div class=\"sub1\" data-v-e1d0e61e><table class=\"st_mybd_list\" data-v-e1d0e61e><colgroup data-v-e1d0e61e><col data-v-e1d0e61e><col style=\"width:14%;\" data-v-e1d0e61e><col style=\"width:14%;\" data-v-e1d0e61e><col style=\"width:14%;\" data-v-e1d0e61e></colgroup><thead data-v-e1d0e61e><tr data-v-e1d0e61e><th scope=\"col\" data-v-e1d0e61e>상품명</th><th scope=\"col\" data-v-e1d0e61e>소요시간</th><th scope=\"col\" data-v-e1d0e61e>인원수</th><th scope=\"col\" data-v-e1d0e61e>가격(원)</th></tr></thead><tbody data-v-e1d0e61e><tr data-v-e1d0e61e><td style=\"text-align:left;padding-left:20px;\" data-v-e1d0e61e> PUTT2.0 학습진로상담 전문가교육 - 초급과정 </td><td data-v-e1d0e61e>15시간</td><td data-v-e1d0e61e>16명 내외</td><td data-v-e1d0e61e>200,000</td></tr><tr data-v-e1d0e61e><td style=\"text-align:left;padding-left:20px;\" data-v-e1d0e61e> PUTT2.0 학습진로상담 전문가교육 - 고급과정 </td><td data-v-e1d0e61e>30시간</td><td data-v-e1d0e61e>16명 내외</td><td data-v-e1d0e61e>250,000</td></tr><tr data-v-e1d0e61e><td style=\"text-align:left;padding-left:20px;\" data-v-e1d0e61e> PUTT2.0 학습진로상담 전문가교육 - 최고과정 </td><td data-v-e1d0e61e>30시간</td><td data-v-e1d0e61e>16명 내외</td><td data-v-e1d0e61e>300,000</td></tr><tr data-v-e1d0e61e><td style=\"text-align:left;padding-left:20px;\" data-v-e1d0e61e> 성장‧폴리오 전문가 과정 </td><td data-v-e1d0e61e>15시간</td><td data-v-e1d0e61e>16명 내외</td><td data-v-e1d0e61e>200,000</td></tr></tbody></table></div><br data-v-e1d0e61e><div data-v-e1d0e61e>◰ 결제 방법:계좌 이체</div><div class=\"sub1\" data-v-e1d0e61e><table class=\"st_mybd_list\" data-v-e1d0e61e><colgroup data-v-e1d0e61e><col data-v-e1d0e61e></colgroup><thead data-v-e1d0e61e><tr style=\"background-color:burlywood;\" data-v-e1d0e61e><th scope=\"col\" data-v-e1d0e61e> 우리은행 1005-104-783814, (예금주) 주식회사 코코랩 </th></tr></thead></table></div>", 7)),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: `${_unref(USER_ROUTES).Price.Org.Path}`
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("이 전 ")
                    ])),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})